import Vue from 'vue'
import Vuex from 'vuex'
import api from './modules/api-data'
import auth from './modules/auth'
import notifications from './modules/notifications'
import campaigns from './modules/campaigns'
import adsets from './modules/adsets'
import audiences from './modules/audiences'
import reports from './modules/reports'
import scraper from './modules/scraper'
import messages from './modules/messages'
import featureToggle from './modules/feature-toggle'
import helpers from './modules/helpers'
import agencies from './modules/agencies'
import advertisers from './modules/advertisers'
import videos from './modules/videos'
import locations from './modules/saved-locations'
import errors from './modules/errors-dictionary'
import preview from './modules/preview'
import mobilize from './modules/mobilize'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    api,
    auth,
    notifications,
    campaigns,
    adsets,
    audiences,
    reports,
    scraper,
    messages,
    featureToggle,
    helpers,
    agencies,
    advertisers,
    videos,
    locations,
    errors,
    preview,
    mobilize
  },
  strict: debug
})
